module.exports = __webpack_public_path__ + "static/img/14n.1e4c494.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/14n.jpg
// module id = zBor
// module chunks = 0